/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class PlatformCompanyRegistrationDto{

  uuid: string | null = null;

  owner: string | null = null;

  companyName: string | null = null;

  registrationCode: string | null = null;

  uniqueIdentificationNumber: string | null = null;

  preferredLanguage: string | null = null;

  mainPhoneNumber: string | null = null;

  mainEmailAddress: string | null = null;
}
